import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ComponentLayout from './ComponentLayout';
import HeadingGroup from './HeadingGroup';
import ContactUs from '../ContactUs';

const SplitView = (props) => {
    const data = props.splitViewData;
    return (
        <div className="split-view-wrapper">
            <ComponentLayout >
                <HeadingGroup headingStrongText={data.headingStrong} description={data.description} />
                <Grid container spacing={6} className="list-wrapper">
                    <Grid item sm={6} xs={12}>
                        <div className="left-heading large-font">{data.innerLeftHeading}</div>
                        <div className="left-description medium-font">{data.innerLeftDescription}</div>
                        {data.listData.map((item) => {
                            return (
                                <div className="list-item">
                                    <Grid container spacing={3}>
                                        <Grid item xs={3} className="column-content column-img">
                                            <img src={item.image} alt={item.heading}/>
                                        </Grid>
                                        <Grid item xs={8} className="column-content">
                                            <div className="item-heading medium-font">{item.heading}</div>
                                            <div className="item-description small-font">{item.description}</div>
                                        </Grid>
                                    </Grid>
                                </div>
                            )
                        })}
                        {data.contactUs &&
                         <div className="button-wrapper"><Link className="yellow-button" to="/contact-us">Contact Us</Link></div>
                        }
                       
                    </Grid>
                    <Grid item sm={6} xs={12} className="main-image-wrapper">
                        <img src={data.mainImage} alt={data.description} className="main-image"/>
                    </Grid>
                </Grid>
            </ComponentLayout>
        </div>
    );
};

SplitView.propTypes = {
    splitViewData: PropTypes.any,
}

export default SplitView;